import ScreenNavigator from "../../../../../lib/html5-software-library/src/ranj/ui/ScreenNavigator";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SmartphoneSetupNavigatorEvent from "../model/SmartphoneSetupNavigatorEvent";

export default class SmartphoneSetupNavigatorCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {ScreenNavigator} smartphoneScreenNavigator 
     */
    constructor(dispatcher, smartphoneScreenNavigator) {
        super(dispatcher);

        this._smartphoneScreenNavigator = smartphoneScreenNavigator;
    }

    execute(evt) {
        /** @type {SmartphoneSetupNavigatorEvent} */
        const data = evt.params.data;

        this._smartphoneScreenNavigator.setContextView(data.contextView);
        this._smartphoneScreenNavigator.setScreenDimensions(data.size.x, data.size.y);
    }
}